import { StaticBaseDao } from '@/dao';
import { ExternalDataSource, ISonenItem, ExternalDatasourceEvent, ExternalEventDatasourceResponse } from '@/objects/generated';
import type { ExternalDatasourceType } from './../enums/ExternalDatasourceType';
import { formatDateIso } from '@/utilities/dateutils';

export class ExternalEventDatasourceDao extends StaticBaseDao {
    public static async ExternalDatasourcesForUser(): Promise<ExternalDataSource[]> {
        return this.BaseFetchArray(ExternalDataSource, `ExternalEventDatasource/ExternalDatasourcesForUser`, 'GET');
    }
    public static async IsonenItemsForUser(): Promise<ISonenItem[]> {
        return this.BaseFetchArray(ISonenItem, `ExternalEventDatasource/IsonenItemsForUser`, 'GET');
    }
    public static async GetDatasourceEvents(
        item: ISonenItem,
        query: string | null,
        after?: Date | null,
    ): Promise<ExternalDatasourceEvent[]> {
        return this.BaseFetchArray(
            ExternalDatasourceEvent,
            `ExternalEventDatasource/GetDatasourceEvents` +
                '?' +
                (query == undefined ? '' : `query=${query}`) +
                '&' +
                (after == undefined ? '' : `after=${after ? formatDateIso(after) : null}`),
            'POST',
            item,
        );
    }
    public static async GetEventDatasourceResponse(
        item: ISonenItem,
        key: string | null,
        update?: boolean,
    ): Promise<ExternalEventDatasourceResponse[]> {
        return this.BaseFetchArray(
            ExternalEventDatasourceResponse,
            `ExternalEventDatasource/GetEventDatasourceResponse` +
                '?' +
                (key == undefined ? '' : `key=${key}`) +
                '&' +
                (update == undefined ? '' : `update=${update}`),
            'POST',
            item,
        );
    }
    public static async HandleExternalDatasourceFiles(
        files: FormData,
        type: ExternalDatasourceType,
    ): Promise<ExternalEventDatasourceResponse[]> {
        return this.PostFormData(
            ExternalEventDatasourceResponse,
            `ExternalEventDatasource/HandleExternalDatasourceFiles` +
                '?' +
                (files == undefined ? '' : `files=${files}`) +
                '&' +
                (type == undefined ? '' : `type=${type}`),
            files,
        );
    }
}
